import {SHORT_TERM_VIEW_TAGS_STORE_KEY} from 'appConstants';
import {type URLParams} from 'interfaces';
import {create} from 'zustand';
import {persist} from 'zustand/middleware';

export const useShortTermViewState = create(
  persist<{
    tags: URLParams[]; // Define the state type
    setTags: (tags: URLParams[]) => void; // Define a setter function
  }>(
    (set) => ({
      tags: [], // Default state
      setTags: (tags) => {
        set({tags});
      }, // Setter function
    }),
    {
      name: SHORT_TERM_VIEW_TAGS_STORE_KEY, // Key for localStorage
    },
  ),
);
